import { getStoreAccessors } from "typesafe-vuex";
import { State } from "../state";
import { IUserDashboardState } from "./state";

export const mutations = {
    setOrdersMetrics(state, payload) {
        state.ordersMetrics = payload;
    },
    setSelectedBranchId(state, payload) {
        state.selectedBranchId = payload;
    }
};

export const { commit } = getStoreAccessors<IUserDashboardState, State>('');
export const commitSetOrdersMetrics = commit(mutations.setOrdersMetrics);
export const commitSetSelectedBranchId = commit(mutations.setSelectedBranchId);


